import {
    DomainInitPayload,
    VehicleState,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getDeviceByVin } from '@sxm-de/dev-kits/web-sdk/domains/devices';
import { normalizeVinForServiceCall } from '@sxm-de/dev-kits/web-sdk/utils';

interface CheckVehicleStatusByVinFnPayload {
    vin: string;
}

export type CheckVehicleStatusByVinFn = (
    payload: CheckVehicleStatusByVinFnPayload,
) => Promise<VehicleState>;

export function initCheckVehicleStatusByVinFn({
    dependencies,
}: DomainInitPayload): CheckVehicleStatusByVinFn {
    return async ({ vin }) => {
        try {
            const status = await getDeviceByVin(
                { vin: normalizeVinForServiceCall(vin) },
                dependencies,
            );
            // TODO: analytics
            return status;
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
